export default {
  GET_relation_info: 'GET_relation_info',
  getRainWaterTotal: 'getRainWaterTotal',
  getDangerAreaInfo: 'getDangerAreaInfo',
  getDangerAreaInfotown: 'getDangerAreaInfotown',
  getPreventionDataInfo: 'getPreventionDataInfo',
  getPreventionDataInfotown: 'getPreventionDataInfotown',
  getWarnVillageByTown: 'getWarnVillageByTown',
  getPreventionDataInfopool: 'getPreventionDataInfopool'
}
